import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from '@progress/kendo-angular-charts';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { GridsterModule } from 'angular-gridster2';
import { AgGridModule } from 'ag-grid-angular';

import { TamDashboardComponent } from './tam-dashboard.component';
import { TamDashboardTileContainerComponent } from './tam-dashboard-tile-container/tam-dashboard-tile-container.component';
import { TamDashboardValueTileComponent } from './tam-dashboard-value-tile/tam-dashboard-value-tile.component';
import { TamDashboardThreadTileComponent } from './tam-dashboard-thread-tile/tam-dashboard-thread-tile.component';
import { TamDashboardPieChartTileComponent } from './tam-dashboard-pie-chart-tile/tam-dashboard-pie-chart-tile.component';
import { TamDashboardColumnChartTileComponent } from './tam-dashboard-column-chart-tile/tam-dashboard-column-chart-tile.component';
import { TamDashboardLineChartTileComponent } from './tam-dashboard-line-chart-tile/tam-dashboard-line-chart-tile.component';
import { TamDashboardMetadataTileComponent } from './tam-dashboard-metadata-tile/tam-dashboard-metadata-tile.component';
import { TamDashboardGridTileComponent } from './tam-dashboard-grid-tile/tam-dashboard-grid-tile.component';
import { WidgetsModule } from '../../widgets/widgets.module';
import { DashboardViewerComponent } from './dashboard-viewer/dashboard-viewer.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TamDashboardDrillDownComponent } from './tam-dashboard-drill-down/tam-dashboard-drill-down.component';
import { CalendarDialogModule } from '../calendar-dialog/calendar-dialog.module';
import { TamDashboardTileContainerDirective } from './tam-dashboard-tile-container/tam-dashboard-tile-container.directive';
import { ThreadDetailComponent } from '../thread-detail/thread-detail.component';
import { ThreadDetailModule } from '../thread-detail/thread-detail.module';
import { DynamicComponentService } from '../../services/dynamic-component.service';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TamDashboardPopUpService } from './tam-dashboard-popup.service';
import { TamDashboardRichTextTileComponent } from './tam-dashboard-rich-text-tile/tam-dashboard-rich-text-tile.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { DashboardTileService } from './dashboard-tile.service';
import { TamDashboardMapTileComponent } from './tam-dashboard-map-tile/tam-dashboard-map-tile.component';
import { ContactEffects } from '../../tamalelibs/redux/contact.effects';
import { EffectsModule } from '@ngrx/effects';
import { ContactViewModel } from '../../tamalelibs/components/contact.view-model';
import { TamDashboardMapTileModule } from './tam-dashboard-map-tile/tam-dashboard-map-tile.module';
import { TamCustomGridColumnFilterComponent } from '../../widgets/ag-grid-column-filter/custom-grid-column-filter.component';
import { TamCustomGroupRowInnerRenderer } from '../../widgets/ag-grid-column-filter/custom-group-row-inner-renderer.component';
import { DashboardEditorSubChromeComponent } from './dashboard-viewer/dashboard-editor-sub-chrome/dashboard-editor-sub-chrome.component';

@NgModule({
    imports: [
        // angular
        CommonModule,
        // 3rd party
        AgGridModule,
        ChartModule,
        GridsterModule,
        FroalaEditorModule.forRoot(),
        FroalaViewModule.forRoot(),
        // kendo
        ButtonsModule,
        DropDownsModule,
        TooltipModule,
        PopupModule,
        // project
        WidgetsModule,
        CalendarDialogModule,
        ThreadDetailModule,
        // map
        TamDashboardMapTileModule,
        EffectsModule.forFeature([ContactEffects])
    ],
    declarations: [
        TamDashboardComponent,
        TamDashboardValueTileComponent,
        TamDashboardThreadTileComponent,
        TamDashboardPieChartTileComponent,
        TamDashboardMapTileComponent,
        TamDashboardColumnChartTileComponent,
        TamDashboardRichTextTileComponent,
        TamDashboardLineChartTileComponent,
        TamDashboardMetadataTileComponent,
        TamDashboardGridTileComponent,
        TamDashboardTileContainerComponent,
        DashboardViewerComponent,
        DashboardEditorSubChromeComponent,
        TamDashboardDrillDownComponent,
        TamDashboardTileContainerDirective,
        TamDashboardMapTileComponent
    ],
    providers: [
        DynamicComponentService,
        TamDashboardPopUpService,
        DashboardTileService,
        ContactViewModel,
    ],
    exports: [
        TamDashboardComponent,
        TamDashboardValueTileComponent,
        TamDashboardThreadTileComponent,
        TamDashboardPieChartTileComponent,
        TamDashboardMapTileComponent,
        TamDashboardColumnChartTileComponent,
        TamDashboardRichTextTileComponent,
        TamDashboardLineChartTileComponent,
        TamDashboardMetadataTileComponent,
        TamDashboardGridTileComponent,
        TamDashboardTileContainerComponent,
        DashboardViewerComponent,
        TamDashboardTileContainerDirective,
        DashboardEditorSubChromeComponent
    ]
})
export class TamDashboardModule { }
